import type { Overview } from '@manaro/contracts'
import { Card } from '@/shared/ui/card.tsx'
import { EmptyState } from '@/shared/ui/states.tsx'

const DOTS: Record<Overview['attention'][number]['level'], string> = {
  high: 'bg-warn-dot',
  mid: 'bg-attention',
  low: 'bg-ink-faint',
}

export function AttentionCard({ items }: { items: Overview['attention'] }) {
  return (
    <Card className="min-w-0 px-5.5 py-5">
      <h2 className="mb-3 font-display text-[17px] font-semibold">Требуют внимания</h2>

      {items.length === 0 ? (
        <EmptyState title="Всё спокойно" description="Ни истекающих подписок, ни брошенных оплат." />
      ) : (
        <div className="flex flex-col">
          {items.map((item) => (
            <div
              key={item.id}
              className="flex items-start gap-2.5 border-t border-line-soft py-2.5 first:border-t-0 first:pt-0"
            >
              <span className={`mt-1.5 size-[7px] shrink-0 rounded-full ${DOTS[item.level]}`} />
              <span className="min-w-0 flex-1">
                <span className="block text-[14px] font-medium">{item.name}</span>
                <span className="block text-[12.5px] text-ink-muted">{item.note}</span>
              </span>
            </div>
          ))}
        </div>
      )}
    </Card>
  )
}
